import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import type React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";

/** Long enough not to fire while scanning across headers, short enough to find by hovering deliberately. */
const TITLE_TOOLTIP_ENTER_DELAY_MS = 600;

export default function ColumnHeader({
  title,
  extra,
  titleTooltip,
}: {
  title: string;
  extra?: React.ReactNode;
  isActive?: boolean;
  /** Scoped to the title rather than the whole header so it doesn't fire when reaching for the filter. */
  titleTooltip?: React.ReactNode;
}) {
  const label = (
    <Typography
      component="span"
      // Tooltips open on focus too, but only for a focusable child — without this the tooltip is mouse-only.
      tabIndex={titleTooltip ? 0 : undefined}
      sx={{ fontWeight: 600, fontSize: "inherit" }}
    >
      {title}
    </Typography>
  );

  return (
    <Box
      data-sb={TestIds.driverView.columnHeader}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {titleTooltip ? (
        <Tooltip
          title={titleTooltip}
          enterDelay={TITLE_TOOLTIP_ENTER_DELAY_MS}
          enterNextDelay={TITLE_TOOLTIP_ENTER_DELAY_MS}
          slotProps={{ tooltip: { sx: { maxWidth: 360, p: 1.25 } } }}
        >
          {label}
        </Tooltip>
      ) : (
        label
      )}
      {extra}
    </Box>
  );
}
